module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-schools-70981ad6e717ca4a4477ef814d4a841c.jpg";